import useActionsComplaintAdvancedForm from './useActionsComplaintAdvancedForm'

export default useActionsComplaintAdvancedForm
